import { z } from "zod";
import { email, pin, senhaNova } from "./comuns";

export const loginSchema = z.object({
  email,
  senha: z.string().min(1, { error: "Informe a senha" }).max(200),
});
export type LoginEntrada = z.input<typeof loginSchema>;

export const trocarSenhaSchema = z
  .object({
    senhaAtual: z.string().min(1, { error: "Informe a senha atual" }).max(200),
    novaSenha: senhaNova,
  })
  .refine((v) => v.novaSenha !== v.senhaAtual, {
    error: "A nova senha precisa ser diferente da atual",
    path: ["novaSenha"],
  });
export type TrocarSenhaEntrada = z.input<typeof trocarSenhaSchema>;

const senhaAtual = z.string().min(1, { error: "Informe a sua senha" }).max(200);

/** ADMIN define ou troca o próprio PIN de autorização, confirmando com a senha. */
export const definirPinSchema = z.object({ pin, senhaAtual });
export type DefinirPinEntrada = z.input<typeof definirPinSchema>;

export const removerPinSchema = z.object({ senhaAtual });
export type RemoverPinEntrada = z.input<typeof removerPinSchema>;
